export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '使用指南',
    slug: 'guide',
    description: '详细的平台使用教程和操作指南，帮助您快速上手 17c.com 的各项功能。',
    icon: 'ri-book-open-line',
    articleCount: 24,
  },
  {
    id: 'cat-2',
    name: '功能介绍',
    slug: 'features',
    description: '深入了解 17c.com 的核心功能模块、特色服务和最新更新动态。',
    icon: 'ri-stack-line',
    articleCount: 18,
  },
  {
    id: 'cat-3',
    name: '常见问题',
    slug: 'faq-articles',
    description: '汇总用户最常遇到的问题及详细解答，让您使用无忧。',
    icon: 'ri-question-answer-line',
    articleCount: 35,
  },
  {
    id: 'cat-4',
    name: '安全与隐私',
    slug: 'security',
    description: '了解 17c.com 的安全防护措施、隐私政策和数据保护机制。',
    icon: 'ri-shield-check-line',
    articleCount: 12,
  },
  {
    id: 'cat-5',
    name: '更新日志',
    slug: 'changelog',
    description: '追踪 17c.com 的版本更新记录、功能迭代和新特性发布。',
    icon: 'ri-file-list-3-line',
    articleCount: 16,
  },
  {
    id: 'cat-6',
    name: '用户故事',
    slug: 'stories',
    description: '真实用户分享的 17c.com 使用体验和成功案例。',
    icon: 'ri-user-heart-line',
    articleCount: 9,
  },
];